export const DUMMY_MAP_TITLE = "The map for this tour is coming soon"
